import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { Observable } from "rxjs/Observable";
import { isInArray } from "../../../core/util/is-in-array";
import * as fromRoot from "../../store/bootstrap";
import { Category } from "./category.model";
import { AccessGroup } from "../access-group/access-group.model";

export abstract class CategoryStoreFacade<T extends Category> extends AccountObjectStoreFacade<T> {

    defaultSortFn = (a: AccessGroup, b: AccessGroup) => a.title.localeCompare(b.title);

    abstract getForAllAccounts(entity: string, entityPlural: string): Observable<Array<T>>;

    protected _getForAllAccounts(entity: string, entityPlural: string): Observable<Array<T>> {
        return this.select((state: fromRoot.State) => {
            const user = state.user.entities[state.user.selected];

            if (!user) {
                return [];
            }

            const accountIdsOwnedByUser = state.account.ids
                .map(id => state.account.entities[id])
                .filter(account => account.owner === user.id)
                .map(account => account.id);

            const accessGroupIds = state.membership.ids
                .map(id => state.membership.entities[id])
                .filter(membership => membership.user === user.id)
                .map(membership => membership[entityPlural])
                .reduce((p, c) => {
                    return p.concat(c);
                }, []);

            return state[entity].ids
                .map(id => state[entity].entities[id])
                .filter(item => {
                    // @see https://git.ironcode.io/vas/vas-rest/issues/219
                    // return isInArray(item.id, accessGroupIds) || isInArray(item.account, accountIdsOwnedByUser);
                    return isInArray(item.id, accessGroupIds);
                })
                .sort(this.defaultSortFn);

        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.store-facade.ts